import { prepareVideoElements } from "../view/manuals/lecture_video/elements";
import { setupVideoPage } from "../view/manuals/lecture_video/video_page";

class ManualsController {
  onLoad(): void {
    const elms = prepareVideoElements();
    if (!elms) {
      return;
    }
    setupVideoPage(elms);
  }
}

export { ManualsController };
